import { AccessMode } from '../../../../types';
import useScormViewer from './hooks/useScormViewer';
import { scormVersionMapping } from './utils/scormVersionMapping';

export enum ScormWrapperEventEnum {
  Finish = 'SCO-Finish',
  Commit = 'SCO-Commit',
  SetValue = 'SCO-SetValue',
  Completion = 'SCO-Completion',
  Close = 'SCO-Close',
  SetPerformance = 'SCO-SetPerformance',
  GetPerformance = 'SCO-GetPerformance',
  Init = 'SCO-Init', // Init event from SCORM for getting the Scorm user data
}

export enum ScormWrapperPostMessageEnum {
  GetData = 'SCO-GetData',
  ContentClose = 'SCO-ContentClose',
  Init = 'SCO-Init', // Init event from SCORM for getting the Scorm user data
}

export type ScormSchemaVersion = keyof typeof scormVersionMapping;

export enum ScormVersions {
  One = '1.2',
  Two = '2004',
}

export enum ScormViewerMode {
  Embed,
  Fullscreen,
}

export interface ScormContentPageRouteParams {
  contentId: string;
}

export interface ScormViewerProps extends ReturnType<typeof useScormViewer> {
  contentId: string;
  accessMode?: AccessMode;
  mode?: ScormViewerMode;
  onLoad?: (name?: string) => void;
  recordProgress?: boolean;
  iframeKey?: string;
  onMessage: (data?: any) => void;
}

export const MESSAGE_SOURCE = 'ly-scorm-content';

export type MessageData = {
  source: 'ly-scorm-content';
  event: ScormWrapperEventEnum;
  scormData: string;
  contentId: string;
};
